import graphqlClient from "../../../apollo";

class ProductCustomProvider {


    fetchProductsHomeGallery() {
        return graphqlClient.query({
            query: require('./gql/Product/productFetchHomeGallery.graphql')
        })
    }

    fetchProductsFiltered(filters) {
        return graphqlClient.query({
            query: require('./gql/Product/productFetchFiltered.graphql'),
            variables: {filters},
            fetchPolicy: "network-only"
        })
    }

    fetchProductByBranch(branchId) {
        return graphqlClient.query({
            query: require('./gql/Product/fetchProductByBranch.graphql'),
            variables: {branchId},
            fetchPolicy: "network-only"
        })
    }


}

export default new ProductCustomProvider()


